import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/freakflags.css';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { ErrorServerBoundary } from 'components/ErrorPage/ErrorPage';
import ThemeProvider from 'providers/ThemeProvider/ThemeProvider';
import * as Sentry from '@sentry/react';
import { isProduction } from 'config/api';
import App from './components/App/App';
// import reportWebVitals from "./reportWebVitals";
import { StoreProvider } from './providers/storeProvider';
import { ErrorBoundary } from './providers/ErrorBoundary';

isProduction && Sentry.init({
  dsn: 'https://ea3f1d3ca4fd225d32cb4ff98fdaba0f@o4506353225760768.ingest.us.sentry.io/4507311313649664',
  integrations: [],
});

// process.env.REACT_APP_MODE !== "test" && localStorage.setItem("token", "123");
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // eslint-disable-next-line react/jsx-filename-extension
  <BrowserRouter>
    <StoreProvider>
      <ThemeProvider>
        <ErrorServerBoundary>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </ErrorServerBoundary>
      </ThemeProvider>
    </StoreProvider>
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
